import { Box, Card, Container, Typography } from '@medely/web-components';
import React from 'react';
import ResetPasswordForm from './RequestResetPasswordForm';

const RequestResetPassword = (): React.ReactElement => (
  <Box mt={5} mb={5}>
    <Box mb={5}>
      <Typography variant="h3" gutterBottom align="center">
        Reset Your Password
      </Typography>
      <Typography variant="subtitle2" align="center">
        If this email exists in our system, we have sent it a password reset link
      </Typography>
    </Box>
    <Container maxWidth="sm">
      <Card variant="outlined">
        <Box p={4}>
          <ResetPasswordForm />
        </Box>
      </Card>
    </Container>
  </Box>
);

export default RequestResetPassword;
